import React, { useMemo, useEffect, useState, useCallback } from "react";

import PageTitle from "jsx/layouts/PageTitle";
import SmallModal from "jsx/components/CitoPlus/components/small_modal";
import { useTable, useFilters, usePagination, useSortBy } from "react-table";
import "../../../table/FilteringTable/filtering.css";
import axiosInstance from "../../../../../services/AxiosInstance";
import { getDefaultParams } from "../../../../../services/DefaultParamets";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

import Tables from "jsx/components/CitoPlus/components/tables";
import SearchInput from "jsx/components/CitoPlus/components/input_search";
import Swal from "sweetalert2";

import {
  notifySuccess,
  notifyError,
} from "jsx/components/CitoPlus/components/CitoPlusToastr";
import FormAgregarActivoZonaSocial from "jsx/components/CitoPlus/Facturacion/FormAgregarActivoZonaSocial";
import {
  CitoPlusLink,
  CitoPlusLinkIconPrimary,
} from "jsx/components/CitoPlus/components/CitoPlusLink";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Badge } from "react-bootstrap";

const ESTADO_LABEL_MAP = {
  nuevo: "Nuevo",
  bueno: "Bueno",
  mantenimiento: "En mantenimiento",
  dado_de_baja: "Dado de baja",
};

const ESTADO_BADGE_MAP = {
  nuevo: "success",
  bueno: "primary",
  mantenimiento: "warning",
  dado_de_baja: "danger",
};

export const ZonaSocialActivos = () => {
  const URL = "/api/v3/zonas-sociales/activos/";

  const [smallModalTitle, setSmallModalTitle] = useState("");
  const [smallModalBody, setSmallModalBody] = useState("");
  const [smallShowModal, setSmallShowModal] = useState(false);

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");

  const [nextUrl, setNextUrl] = useState([]);
  const [previousUrl, setPreviousUrl] = useState([]);

  const [defaultParams, setDefaultParams] = useState(getDefaultParams);

  // Agregar Activos
  const [showModalAddActivo, setShowModalAddActivo] = useState(false);
  const [selectedZonaSocialUUID, setSelectedZonaSocialUUID] = useState(null);
  const [selectedActivoUUID, setSelectedActivoUUID] = useState(null);
  const [editActivo, setEditActivo] = useState(false);

  const handleModalAgregarActivos = (
    zonaSocialUUID,
    activoUUID = null,
    editMode = false,
  ) => {
    setEditActivo(editMode);
    setSelectedZonaSocialUUID(zonaSocialUUID);
    setSelectedActivoUUID(activoUUID);
    setShowModalAddActivo(true);
  };
  // FIN Agregar Activos

  const columns = useMemo(
    () => [
      {
        id: "nombre",
        Header: "Nombre",
        disableFilters: true,
        disableSortable: false,
        accessor: (row) => {
          return (
            <>
              <ul>
                <li><strong>{row.nombre}</strong></li>
                <li>{row.observaciones || "-"}</li>
              </ul>
            </>
          );
        },
      },
      {
        id: "zona_nombre",
        Header: "Zona",
        disableFilters: true,
        disableSortable: false,
        accessor: (row) => {
          return (
            <>
              <ul>
                <li>{row.zona?.nombre || "-"}</li>
              </ul>
            </>
          );
        },
      },
      {
        id: "cantidad",
        Header: "Cantidad",
        accessor: "cantidad",
        disableFilters: true,
        disableSortable: false,
      },
      {
        id: "estado",
        Header: "Estado",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <Badge bg={ESTADO_BADGE_MAP[row.estado] || "secondary"}>
              {ESTADO_LABEL_MAP[row.estado] || row.estado}
            </Badge>
          );
        },
      },
      {
        id: "activo",
        Header: "Activo",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <Badge bg={row.activo ? "success" : "secondary"}>
              {row.activo ? "Sí" : "No"}
            </Badge>
          );
        },
      },
      {
        id: "uuid",
        Header: "Acciones",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <>
              <ButtonGroup aria-label="Botones de acciones activos">
                <CitoPlusLinkIconPrimary
                  onClick={() => {
                    handleModalAgregarActivos(null, row.uuid, true);
                  }}
                  onClose={() => {
                    setEditActivo(false);
                    setSelectedZonaSocialUUID(null);
                    setSelectedActivoUUID(null);
                  }}
                  title="Editar"
                >
                  <i className="fas fa-pencil-alt"></i>
                </CitoPlusLinkIconPrimary>
              </ButtonGroup>
            </>
          );
        },
      },
    ],
    [],
  );

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedFetchUnidades = useCallback(
    debounce((pageIndex, search) => {
      fetchUrl(pageIndex, search);
    }, 500),
    [],
  );

  useEffect(() => {
    fetchUrl(1);
  }, []);

  const fetchUrl = async (pageIndex = 1, search = "", ordering = []) => {
    defaultParams.page = pageIndex;
    defaultParams.search = search;
    setLoading(true);
    try {
      if (pageIndex < 1 || pageIndex > totalPages) {
        notifyError("Página no encontrada");
        return;
      }
      const response = await axiosInstance.get(URL, {
        params: {
          ...defaultParams,
          page: pageIndex,
          search: search,
          order_by: ordering,
        },
      });
      setNextUrl(response.data.next);
      setPreviousUrl(response.data.previous);
      setTotalPages(response.data.total_pages);
      setCurrentPage(response.data.current_page);
      setData(response.data.results);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 404) {
        setSmallModalTitle("Título del Modal");
        setSmallModalBody("Contenido del Modal");
        setSmallShowModal(true);
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const updateInmueblesList = async () => {
    await fetchUrl(
      currentPage,
      searchValue,
      `${order === "desc" ? "-" : ""}${sortField}`,
    );
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setLoading(true);
    debouncedFetchUnidades(1, value);
  };

  const handleEnterPress = () => {
  };

  const handleClearClick = () => {
    handleSearchChange("");
  };

  const handleSortingChange = (column) => {
    const { id } = column;

    const newOrder =
      sortField === id ? (order === "asc" ? "desc" : "asc") : "asc";

    setSortField(id);
    setOrder(newOrder);
    setLoading(true);
    fetchUrl(1, searchValue, `${newOrder === "desc" ? "-" : ""}${id}`);
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      pageCount: totalPages,
    },
    useFilters,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    toggleAllRowsSelected,
  } = tableInstance;

  return (
    <>
      <div className="d-flex aling-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">Activos de Zonas Sociales</h4>
        <CitoPlusLink
          to={"#"}
          className="btn btn-citoplus-primary"
          onClick={() => {
            handleModalAgregarActivos(null);
          }}
        >
          Agregar Activo
        </CitoPlusLink>
      </div>
      <div className="card">
        <div className="card-header">
          <div className="card-tools">
            <SearchInput
              onSearchChange={handleSearchChange}
              onEnterPress={handleEnterPress}
              onClearClick={handleClearClick}
            />
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="py-5 text-center">
              <SpinnerCitoPlus text="Cargando activos..." />
            </div>
          ) : data.length === 0 ? (
            <p>No hay datos disponibles.</p>
          ) : (
            <Tables
              columns={columns}
              data={data}
              totalPages={totalPages}
              currentPage={currentPage}
              fetchUrl={fetchUrl}
              handleSortingChange={handleSortingChange}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              sortField={sortField}
              order={order}
              page={page}
            />
          )}
        </div>
      </div>

      <div>
        {smallShowModal && (
          <SmallModal
            title={smallModalTitle}
            body={smallModalBody}
            show_modal={smallShowModal}
            onClose={() => setSmallShowModal(false)}
          />
        )}
      </div>

      {/* MODAL AGREGAR ACTIVO ZONA SOCIAL */}
      {showModalAddActivo && (
        <FormAgregarActivoZonaSocial
          showModal={showModalAddActivo}
          onClose={() => {
            setShowModalAddActivo(false);
            setSelectedZonaSocialUUID(null);
            setEditActivo(false);
            setSelectedActivoUUID(null);
          }}
          updateList={fetchUrl}
          selectedZonaSocialUUID={selectedZonaSocialUUID}
          selectedActivoUUID={selectedActivoUUID}
          editMode={editActivo}
        />
      )}
    </>
  );
};

export default ZonaSocialActivos;
